// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.add-user {
  color: #fff;
  background-color: #050e25;
  height: calc(100vh - 180px);
  width: 100%;
  padding-left: 40px;
  padding-right: paddingLeftSize;
  padding-top: 0px;
  margin-top: 90px; }
  .add-user .container {
    margin-left: unset;
    padding-left: unset;
    margin-top: 30px; }
    .add-user .container input,
    .add-user .container select {
      margin-bottom: 50px; }
    .add-user .container .form-floating select {
      padding-bottom: 0px; }
    .add-user .container .row {
      height: 90px; }
  .add-user .footer {
    position: relative;
    left: 0px;
    z-index: 1; }
  .add-user .form-check {
    text-align: left;
    margin: unset;
    padding: unset;
    margin-bottom: 20px; }
    .add-user .form-check input[type='checkbox'] {
      border-color: unset;
      width: 20px;
      height: 20px;
      padding: unset;
      margin: unset;
      background: transparent;
      border: 1px #fff solid;
      margin-right: 10px;
      cursor: pointer; }
    .add-user .form-check input[type='checkbox']:checked {
      background: #4fc2d9;
      color: #0b1736; }
    .add-user .form-check label.form-check-label {
      text-align: left;
      color: #fff !important; }
  .add-user .role-check-container {
    display: flex;
    flex-wrap: wrap; }
  .add-user .role-check {
    margin-bottom: 20px;
    width: 220px;
    margin-right: 20px; }
    .add-user .role-check .form-check {
      margin-bottom: unset; }
    .add-user .role-check select.reports-dropdownlist {
      background-color: transparent;
      border: unset;
      margin: unset;
      padding: unset;
      padding-left: 30px;
      width: 200px; }
  .add-user .add-company {
    margin-bottom: 30px;
    cursor: pointer; }
    .add-user .add-company img {
      margin-right: 10px; }
  .add-user .form-check-label {
    cursor: pointer; }
  .add-user .form-readonly .form input {
    background-color: #060e21;
    color: #fff; }
  .add-user .form-readonly .form-control[readonly] {
    background-color: #060e21;
    color: #fff; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/users/add-user.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;AClBrD;EACC,WDNsB;ECOtB,yBDMuC;ECLvC,2BAA2B;EAC3B,WAAW;EAEX,kBATqB;EAUrB,8BAA8B;EAC9B,gBAVmB;EAWnB,gBAAgB,EAAA;EATjB;IAYE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB,EAAA;IAdlB;;MAkBG,mBAAmB,EAAA;IAlBtB;MAsBG,mBAAmB,EAAA;IAtBtB;MA0BG,YAAY,EAAA;EA1Bf;IA+BE,kBAAkB;IAClB,SAAS;IACT,UAAU,EAAA;EAjCZ;IAqCE,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,mBAAmB,EAAA;IAxCrB;MA2CG,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,cAAc;MACd,aAAa;MACb,uBAAuB;MACvB,sBAAsB;MACtB,kBAAkB;MAClB,eAAe,EAAA;IAnDlB;MAuDG,mBD3DyB;MC4DzB,cD3DqB,EAAA;ICGxB;MA4DG,gBAAgB;MAChB,sBAAoC,EAAA;EA7DvC;IAkEE,aAAa;IACV,eAAe,EAAA;EAnEpB;IAuEE,mBAAmB;IACnB,YAAY;IACZ,kBAAkB,EAAA;IAzEpB;MA2EG,oBAAoB,EAAA;IA3EvB;MA+EG,6BAA6B;MAC7B,aAAa;MACb,aAAa;MACb,cAAc;MACd,kBAAkB;MAClB,YAAY,EAAA;EApFf;IA2FE,mBAAmB;IACnB,eAAe,EAAA;IA5FjB;MA+FG,kBAAkB,EAAA;EA/FrB;IAqGE,eAAe,EAAA;EArGjB;IA0GG,yBAAyB;IACzB,WAAW,EAAA;EA3Gd;IA+GG,yBAAyB;IACzB,WAAW,EAAA","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import '../../theme/_variables.scss';\n\n$paddingLeftSize: 40px;\n$paddingTopSize: 0px;\n\n.add-user {\n\tcolor: $primaryFontColor;\n\tbackground-color: $containerScreenBackgroundColor;\n\theight: calc(100vh - 180px);\n\twidth: 100%;\n\n\tpadding-left: $paddingLeftSize;\n\tpadding-right: paddingLeftSize;\n\tpadding-top: $paddingTopSize;\n\tmargin-top: 90px;\n\n\t.container {\n\t\tmargin-left: unset;\n\t\tpadding-left: unset;\n\t\tmargin-top: 30px;\n\n\t\tinput,\n\t\tselect {\n\t\t\tmargin-bottom: 50px;\n\t\t}\n\n\t\t.form-floating select{\t\n\t\t\tpadding-bottom: 0px;\n\t\t}\n\n\t\t.row {\n\t\t\theight: 90px;\n\t\t}\n\t}\n\n\t.footer {\n\t\tposition: relative;\n\t\tleft: 0px;\n\t\tz-index: 1;\n\t}\n\n\t.form-check {\n\t\ttext-align: left;\n\t\tmargin: unset;\n\t\tpadding: unset;\n\t\tmargin-bottom: 20px;\n\n\t\tinput[type='checkbox'] {\n\t\t\tborder-color: unset;\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tpadding: unset;\n\t\t\tmargin: unset;\n\t\t\tbackground: transparent;\n\t\t\tborder: 1px #fff solid;\n\t\t\tmargin-right: 10px;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\tinput[type='checkbox']:checked {\n\t\t\tbackground: $secundaryFontColor;\n\t\t\tcolor: $thirdFontColor;\n\t\t}\n\n\t\tlabel.form-check-label {\n\t\t\ttext-align: left;\n\t\t\tcolor: $primaryFontColor  !important;\n\t\t}\n\t}\n\n\t.role-check-container {\n\t\tdisplay: flex;\n    \tflex-wrap: wrap;\n\t}\n\n\t.role-check {\n\t\tmargin-bottom: 20px;\n\t\twidth: 220px;\n\t\tmargin-right: 20px;\n\t\t.form-check {\n\t\t\tmargin-bottom: unset;\n\t\t}\n\n\t\tselect.reports-dropdownlist {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: unset;\n\t\t\tmargin: unset;\n\t\t\tpadding: unset;\n\t\t\tpadding-left: 30px;\n\t\t\twidth: 200px;\n\t\t}\n\n\n\t}\n\n\t.add-company {\n\t\tmargin-bottom: 30px;\n\t\tcursor: pointer;\n\n\t\timg {\n\t\t\tmargin-right: 10px;\n\t\t}\n\n\t}\n\n\t.form-check-label {\n\t\tcursor: pointer;\n\t}\n\n\t.form-readonly{\n\t\t.form input {\n\t\t\tbackground-color: #060e21;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t\t.form-control[readonly]{\n\t\t\tbackground-color: #060e21;\n\t\t\tcolor: #fff;\t\t\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
